import { render, staticRenderFns } from "./TermsOfDeliverySelect.vue?vue&type=template&id=3569140c&"
import script from "./TermsOfDeliverySelect.vue?vue&type=script&lang=ts&"
export * from "./TermsOfDeliverySelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports